import { ChangeEvent, useCallback, useContext, useState } from 'react';
import {
  IStationSwitcherContext,
  StationSwitcherContext,
} from '@components/providers/station/context.tsx';
import { useHttp } from '@hooks/use-http';

export const useVersionUploader = (onClose: () => void) => {
  const http = useHttp();
  const { station } = useContext<IStationSwitcherContext>(
    StationSwitcherContext,
  );
  const [name, setName] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const onChangeName = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  }, []);

  const onChangeFile = useCallback((file: File) => {
    setFile(file);
  }, []);

  const onSuccess = useCallback(() => {
    if (!station) return;
    setLoading(true);
    http.lastmile.createVersion(name, file!, station.station, station.country).finally(() => {
      setLoading(false);
      onClose();
    });
  }, [name, file, station, http, onClose]);

  return { name, file, loading, onSuccess, onChangeName, onChangeFile };
};
